import { useNavigate } from "react-router-dom";
import PublicHeader from "@/components/PublicHeader";
import { MarketplaceGuideModal } from "@/components/MarketplaceGuide";

export default function Guide() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#FDFBF7]" data-testid="guide-page">
      <PublicHeader />
      <MarketplaceGuideModal
        open={true}
        onClose={() => navigate("/")}
        onExplore={() => navigate("/dashboard")}
      />
    </div>
  );
}
